import React from 'react'

import { Video } from '@peracto/peracto-blocks-tailwind'

import Form from './Form/VideoForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }
    const RenderComponent = Video

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/video',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            url: '',
            poster: '',
            autoPlay: false,
            loop: false,
            controls: false,
            showControlsOnHover: false,
            muted: false,
            playsInline: false,
        }),
    }
}

export default createPlugin
